<template>
  <data-table
    v-if="fields"
    :headers="fields"
    class="invoicing-table px-0"
    :items="items"
    :hide-footer="false"
    item-key="ref"
    :loaded="loaded"
  >
    <template v-slot:[`item.date`]="{ item }">
      <div>
        {{ item.FromDate | dateTimeFormat }}
      </div>
    </template>
    <template v-slot:[`item.Price`]="{ item }">
      <div>
        {{ item.Price | price }}
      </div>
    </template>
    <template v-slot:[`item.pdf`]="{ item }">
      <div class="invoicing-table__download"><v-spacer /><a :href="item.pdf_download" :download="item.pdf_download">
        <apio-icon
          name="ui-download"
          lightModeColour="black"
          darkModeColour="white"
        /></a>
      </div>
    </template>
  </data-table>
</template>

<script>

import dayjs from "dayjs";
var utc = require("dayjs/plugin/utc"); // dependent on utc plugin
var timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  name: "InvoicingTable",
  components: {
    DataTable: () => import("@/components/DataTable/DataTable.vue"),
  },
  props: {
    items: {}
  },
  filters: {
    dateTimeFormat(dateTime) {
      // incoming format 2021-03-01T10:44:34Z
      const date = new dayjs.tz(dateTime).format("DD/MM/YYYY");
      return date;
    },
  },
  mounted() {
    this.loaded = true;
  },
  data() {
    return {
      loaded: false,
      fields: [
        {
          value: "date",
          text: "Date",
          width: "29%",
        },
        // {
        //   value: "invoice_number",
        //   text: "Invoice number",
        //   width: "50%",
        // },
        {
          value: "Price",
          text: "Total",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.invoicing-table {
  max-width: 940px;
  &__download {
    display: flex;
    align-content: space-between;
    cursor: pointer;
  }
}
</style>
